module.exports = __webpack_public_path__ + "static/media/addRowIcon.de420ddf.svg";